var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg055Cube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432,0H201c-21.923,0-43.098,9.131-58.155,25.064L30.406,137.269C11.895,151.934,0,174.604,0,200v232 c0,44.112,35.888,80,80,80h231c22.748,0,43.309-9.544,57.889-24.838c0.105-0.1,0.21-0.201,0.314-0.304l119.424-118.349 l0.104-0.104C503.737,353.314,512,333.282,512,312V80C512,35.888,476.112,0,432,0z M171.321,53.157l0.472-0.487 C179.442,44.5,189.815,40,201,40h230.893l-87.432,87.338C334.275,122.629,322.939,120,311,120H104.338L171.321,53.157z M472,312 c0,10.618-4.113,20.612-11.583,28.151L391,408.943V372c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v60 c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40V200c0-22.056,17.944-40,40-40h231c22.056,0,40,17.944,40,40v72 c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-72c0-17.634-5.735-33.953-15.438-47.191l91.727-91.628 C470.294,66.793,472,73.201,472,80V312z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg055Cube);
export default __webpack_public_path__ + "static/media/055-cube.476cafa24654841c35c92b83399898fa.svg";
export { ForwardRef as ReactComponent };